import { Component, computed, inject, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { MaloupeLocale } from '@malou-io/package-utils';

import { PartnerThemeContext } from ':core/context/partner-theme.context';
import { LogoPathResolverPipe } from ':shared/pipes';

@Component({
    selector: 'app-restaurant-logo-footer',
    imports: [TranslateModule, LogoPathResolverPipe],
    templateUrl: './restaurant-logo-footer.component.html',
    styleUrl: './restaurant-logo-footer.component.scss',
})
export class RestaurantLogoFooterComponent {
    private readonly _translateService = inject(TranslateService);
    private readonly _partnerThemeContext = inject(PartnerThemeContext);

    readonly isEnglish = signal<boolean>(false);

    protected readonly partnerTheme = this._partnerThemeContext.activeTheme;
    protected readonly isPartnerMode = computed(() => !!this.partnerTheme());
    protected readonly poweredByText = computed(() => this.partnerTheme()?.footer.poweredByText ?? null);

    constructor() {
        this.isEnglish.set(this._translateService.currentLang === MaloupeLocale.EN);
    }
}
